<template>
    <v-menu class="minionbg" top :offset-x="true" v-if="validShow" @keydown.ctrl.down.native="$emit('keydown-ctrl-down')">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs"  v-on="on"  icon>
            <v-icon color="error" @keydown.ctrl.down.native="$emit('keydown-ctrl-down')">mdi-alert-circle</v-icon>
            </v-btn>
        </template>
        <ul  class="minionbg pa-2">
            <li style="color:red" v-for="(message,index) in value" :key="index">◖ {{message}}</li>
        </ul>
    </v-menu>
</template>
<script>
export default {
    props:["value","minions","identity"],
    computed:{
        validShow(){
            if( this.value==[] || this.value==null || this.value==undefined ||this.value.length==0 || this.minions!=this.identity )
            {
                return false;
            }
            return true;
        }
    }
}
</script>

<style >

.minionbg{
background:#eeeB !important
}
</style>
